import { CheckboxFilterOption } from "@/shared/components/filter/CheckboxFilterGroup";
import { FilterChipItem } from "@/shared/components/filter/FilterChipList";

export interface FilterChipGroup {
  key: string;
  title: string;
  options: CheckboxFilterOption[];
}

interface BuildFilterChipsParams {
  groups: FilterChipGroup[];
  getSelectedValues: (key: string) => (string | number)[];
  onRemove: (key: string, value: string | number) => void;
  formatLabel?: (title: string, optionLabel: string) => string;
}

/**
 * 선택된 필터 값들을 FilterChipList가 사용할 FilterChipItem[]로 변환한다.
 * 특정 필터 shape에 묶이지 않도록 그룹 정의 + 값 조회/제거 콜백만 받는다.
 */
export function buildFilterChips({
  groups,
  getSelectedValues,
  onRemove,
  formatLabel = (title, optionLabel) => `${title}: ${optionLabel}`,
}: BuildFilterChipsParams): FilterChipItem[] {
  return groups.flatMap((group) => {
    const values = getSelectedValues(group.key);
    return values.map((value) => {
      // 값이 querystring 파싱 과정에서 number/string으로 섞여 들어올 수 있어
      // 양쪽을 문자열로 정규화해 비교한다.
      const optionLabel =
        group.options.find(
          (option) => String(option.value) === String(value)
        )?.label ?? String(value);
      return {
        id: `${group.key}-${value}`,
        label: formatLabel(group.title, optionLabel),
        onRemove: () => onRemove(group.key, value),
      };
    });
  });
}
